import { IsNotEmpty } from 'class-validator';
import { Mapper } from '../../../common/ddd/mapper.base';
import { ChallengeFocusScoreEntity } from '../../../core/domain/entities/challenge-insights/challenge-focus-score.entity';
import { GetAccountMetricsInsightChartDataResponse } from '../../../interface/dtos/challenge-insights/get-account-metrics-insight-digital-working-hours-chart-data.response.dto';
import { IOrgWorkingSessionsAnalyticsActivityEnum } from '../../../common/enum/working-sessions/org-working-sessions-analytics-activity.enum';

export class ChallengeFocusScoreChartDataPersistenceResponse {
  @IsNotEmpty()
  [IOrgWorkingSessionsAnalyticsActivityEnum.DayCount]: string;
  @IsNotEmpty()
  [IOrgWorkingSessionsAnalyticsActivityEnum.FocusPercentage]: string;
  @IsNotEmpty()
  [IOrgWorkingSessionsAnalyticsActivityEnum.UserId]: string;
  @IsNotEmpty()
  [IOrgWorkingSessionsAnalyticsActivityEnum.LocalSessionStartDate]: string;
}

export class ChallengeFocusScoreChartDataMapper
  implements
    Omit<
      Mapper<
        ChallengeFocusScoreEntity,
        GetAccountMetricsInsightChartDataResponse
      >,
      'toDomain'
    >
{
  toDomain(
    record: ChallengeFocusScoreChartDataPersistenceResponse
  ): ChallengeFocusScoreEntity {
    return ChallengeFocusScoreChartDataMapper.toDomain(record);
  }

  static toDomain(
    record: ChallengeFocusScoreChartDataPersistenceResponse
  ): ChallengeFocusScoreEntity {
    const entity = ChallengeFocusScoreEntity.create({
      value: Number(
        record[IOrgWorkingSessionsAnalyticsActivityEnum.FocusPercentage]
      ),
      count: Number(record[IOrgWorkingSessionsAnalyticsActivityEnum.DayCount]),
      userId: String(record[IOrgWorkingSessionsAnalyticsActivityEnum.UserId]),
      date: String(
        record[IOrgWorkingSessionsAnalyticsActivityEnum.LocalSessionStartDate]
      ),
    });
    return entity;
  }
  toResponse(
    entity: ChallengeFocusScoreEntity
  ): GetAccountMetricsInsightChartDataResponse {
    return ChallengeFocusScoreChartDataMapper.toResponse(entity);
  }
  static toResponse(
    entity: ChallengeFocusScoreEntity
  ): GetAccountMetricsInsightChartDataResponse {
    return {
      value: entity.value === null ? null : Math.round(entity.avg),
      formattedValue: `${Math.round(entity.avg)}`,
      totalValue: entity.value === null ? null : Math.round(entity.value),
      formattedTotalValue: `${Math.round(entity.value)}`,
      date: entity.date.toISOString().split('T')[0],
      uniqueUserCount: entity.userCount,
    };
  }
}
